import { ACTIVITY_LOG_ROUTE_ID } from './common';
import ActivityLogAdmin from './components/ActivityLogAdmin';

export default {
    [ACTIVITY_LOG_ROUTE_ID]: () => <ActivityLogAdmin />
};
